//import 'babel-polyfill';
import "core-js/stable";

$(() => {
    let firstLoad = true;

    let onCategoryButtonClick = (e) => {
        selectButton($(e.currentTarget).attr('categoryId'));

        $('.regulation-item').each((i, el) => {
            let visible = false;
            $(el).find('.regulation-categories > .regulation-category').each((i, el) => {
                let correctButton = buttons.find(button => button.id === $(el).attr('categoryId'));

                if (correctButton) {
                    if (correctButton.visible) {
                        visible = true
                    }
                }
            })

            visible ? $(el).show() : $(el).hide();
        })
    }

    let buttons = [];

    $('button.category-button').each((i, el) => {
        $(el).on('click', onCategoryButtonClick);

        buttons.push({
            id: $(el).attr('categoryId'),
            item: el,
            visible: true
        })
    })

    let selectButton = (id) => {
        let target = buttons.find(button => button.id === id);
        let otherItems = buttons.filter(button => button !== target);

        if (buttons.every(item => item.visible)) {
            target.visible = true;
            otherItems.forEach(item => item.visible = false)
        } else {
            target.visible = !target.visible;
        }

        if (buttons.every(item => !item.visible)) {
            buttons.forEach(item => item.visible = true)
        }

        buttons.forEach(button => {
            if (button.visible)
                $(button.item).removeClass('btn-default').addClass('btn-primary').attr('aria-pressed', true);
            else
                $(button.item).removeClass('btn-primary').addClass('btn-default').attr('aria-pressed', false);
        })

        // Open all accordions when a category is selected
        if (firstLoad) {

            $('.fiva-accordion.mok-frontpage .panel-collapse').collapse('show');
            $('.fiva-accordion.mok-frontpage .accordion-opener').addClass('open');
            $('.fiva-accordion.mok-frontpage .accordion-opener').attr('aria-expanded', 'true');

            firstLoad = false;
        }
    };
})